export const showEditEmployeeMessage = bool => ({
  type: 'SHOW_EDIT_EMPLOYEE_MESSAGE',
  bool
})
